import { CollapseCode } from './codeHighlights/CollapseCode';

const Collapse: React.FC = () => {
  return (
    <>
      <h1>Collapse</h1>

      <p className="d-inline-flex gap-1">
        <a
          className="btn btn-primary"
          data-bs-toggle="collapse"
          href="#collapseExample"
          role="button"
          aria-expanded="false"
          aria-controls="collapseExample"
        >
          Link with href
        </a>
        <button
          className="btn btn-primary"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseExample"
          aria-expanded="false"
          aria-controls="collapseExample"
        >
          Button with data-bs-target
        </button>
      </p>
      <div className="collapse" id="collapseExample">
        <div className="card card-body">
          Some placeholder content for the collapse component. This panel is
          hidden by default but revealed when the user activates the relevant
          trigger.
        </div>
      </div>

      <div className="mt-5">
        <h2>Collapse HTML-Example</h2>
        <CollapseCode />
      </div>
    </>
  );
};

export default Collapse;
